export type Capability = {
  n: string;
  title: string;
  body: string;
  tag: string;
};

export const CAPABILITIES: Capability[] = [
  {
    n: "01",
    title: "Morning brief",
    body: 'Wake up to a triaged inbox. "These three need you, the rest are handled."',
    tag: "07:00 daily",
  },
  {
    n: "02",
    title: "Deal radar",
    body: "Watches every active thread. Pings you the moment one starts going cold — before you've noticed.",
    tag: "always on",
  },
  {
    n: "03",
    title: "Follow-up drafts",
    body: "Drafts replies in your voice from your recent chat history. Telegram send is off by default — flip the switch when you trust the drafts.",
    tag: "on demand",
  },
  {
    n: "04",
    title: "Pre-call brief",
    body: "Auto-pushes context 20 min before any meeting. Last 5 msgs, open threads, what they want.",
    tag: "20 min pre-call",
  },
  {
    n: "05",
    title: "Memory recall",
    body: '"Who is Dani Park again?" Pulls from past chats, Apollo, LinkedIn — instantly.',
    tag: "instant",
  },
  {
    n: "06",
    title: "After-event enrich",
    body: "Set it up once. The morning after every event or meetup, the new people you met are in your CRM — with research, context, and a draft ready.",
    tag: "automation",
  },
  {
    n: "07",
    title: "Smart watchlists",
    body: 'In English: "DM me if anyone from OKX messages." Sidestack figures out the rest.',
    tag: "plain english",
  },
  {
    n: "08",
    title: "Auto-sync",
    body: "Push deals into HubSpot, notes into Notion, tasks into Linear. Without breaking flow.",
    tag: "integrated",
  },
];
